import React from "react";

export const Text = ({ className = "", cursive, largeFont, ...rest }) => (
  <div
    className={`
      ${largeFont ? "large-font" : ""}
      ${cursive ? "fancy-font" : ""}
      ${className}
    `}
    {...rest}
  />
);

export const TextXs = ({ className = "", ...rest }) => (
  <Text
    className={`
      text-xs leading-4
      sm:text-xs sm:leading-4
      md:text-sm md:leading-5
      lg:text-sm lg:leading-5
      xl:text-base xl:leading-6
      3xl:text-lg 3xl:leading-7
      5xl:text-xl 5xl:leading-8
      ${className}
    `}
    {...rest}
  />
);

export const TextSm = ({ className = "", ...rest }) => (
  <Text
    className={`
      text-sm leading-5
      sm:text-sm sm:leading-5
      md:text-base md:leading-6
      lg:text-base lg:leading-6
      xl:text-lg xl:leading-7
      3xl:text-xl 3xl:leading-8
      5xl:text-2xl 5xl:leading-9
      ${className}
    `}
    {...rest}
  />
);

export const TextMd = ({ className = "", ...rest }) => (
  <Text
    className={`
      text-base leading-6
      sm:text-base sm:leading-6
      md:text-lg md:leading-7
      lg:text-lg lg:leading-7
      xl:text-xl xl:leading-8
      3xl:text-2xl 3xl:leading-9
      5xl:text-3xl 5xl:leading-10
      ${className}
    `}
    {...rest}
  />
);

export const TextLg = ({ className = "", ...rest }) => (
  <Text
    className={`
      text-lg leading-7
      sm:text-lg sm:leading-7
      md:text-xl md:leading-8
      lg:text-2xl lg:leading-9
      xl:text-3xl xl:leading-10
      3xl:text-4xl 3xl:leading-tight
      5xl:text-5xl 5xl:leading-tight
      ${className}
    `}
    {...rest}
  />
);

export const TextXl = ({ className = "", ...rest }) => (
  <Text
    className={`
      text-xl leading-7
      sm:text-xl sm:leading-7
      md:text-2xl md:leading-8
      lg:text-3xl lg:leading-9
      xl:text-4xl xl:leading-tight
      3xl:text-5xl 3xl:leading-tight
      5xl:text-6xl 5xl:leading-tight
      ${className}
    `}
    {...rest}
  />
);

export const Text2xl = ({ className = "", ...rest }) => (
  <Text
    className={`
      text-2xl leading-tight
      sm:text-2xl
      md:text-3xl
      lg:text-4xl
      xl:text-5xl
      3xl:text-6xl
      5xl:text-7xl
      ${className}
    `}
    {...rest}
  />
);

export const Text3xl = ({ className = "", ...rest }) => (
  <Text
    className={`
      text-3xl leading-tight
      sm:text-3xl
      md:text-4xl
      lg:text-5xl
      xl:text-6xl
      3xl:text-7xl
      5xl:text-8xl
      ${className}
    `}
    {...rest}
  />
);

export const Text4xl = ({ className = "", ...rest }) => (
  <Text
    className={`
      text-4xl leading-[0.95]
      sm:text-4xl
      md:text-5xl
      lg:text-6xl
      xl:text-7xl
      2xl:text-8xl
      3xl:text-9xl
      5xl:text-[10rem]
      ${className}
    `}
    {...rest}
  />
);